import React from 'react'
import '../style.css'
export default function New_client() {
    return (
        <div>
            
        </div>
    )
}
